import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const activate = (data) => axios({
  method: 'post',
  url: config.endpoints.sentiment.activate,
  data,
  headers: getHeaders(true)
})

const change = (data) => axios({
  method: 'post',
  url: config.endpoints.sentiment.change,
  data,
  headers: getHeaders(true)
})

export default {
  activate,
  change
}
